<template>
  <el-card class="page-container">
    <el-row>
      <el-row class="search">
        <span>资源类型：</span>
        <el-select
          filterable
          v-model="search.propType"
          clearable
          placeholder=""
        >
          <el-option
            v-for="(item, itemIndex) in propTypeList"
            v-bind:key="itemIndex + 99"
            :label="item.name"
            :value="item.values"
          ></el-option>
        </el-select>
        <span> 是否永久：</span
        ><el-select
          filterable
          v-model="search.expireTime"
          clearable
          placeholder=""
        >
          <el-option
            v-for="(item, itemIndex) in expireList"
            v-bind:key="itemIndex + 99"
            :label="item"
            :value="itemIndex"
          ></el-option>
        </el-select>
        <span> 资源id：</span>
        <el-input
          type="text"
          v-model="search.propId"
          placeholder="请输入物品名"
        ></el-input>
        <span> 用户rid：</span>
        <el-input
          type="text"
          v-model="search.rid"
          placeholder="请输入物品ID"
        ></el-input>
        <el-button type="primary" @click="query" :loading="loading">
          查询
        </el-button>
        <el-button type="warning" @click="operate(1)"> 新增 </el-button>
      </el-row>
      <el-row>
        <el-table
          :data="datalist"
          style="width: 100%"
          v-loading="loading"
          height="60vh"
          stripe
          border
        >
          <el-table-column prop="rid" label="用户rid "> </el-table-column>
          <el-table-column label="用户类型">
            <template slot-scope="scope">
              {{ scope.row.gender == 2 ? '主播' : '用户' }}
            </template>
          </el-table-column>
          <el-table-column prop="propId" label="资源id"> </el-table-column>
          <el-table-column prop="propName" label="资源名称"> </el-table-column>
          <el-table-column label="资源类型">
            <template slot-scope="scope">
              {{
                propTypeList.find((item) => item.values == scope.row.propType)
                  .name
              }}
            </template>
          </el-table-column>
          <el-table-column label="资源图标">
            <template slot-scope="scope">
              <el-image
                style="width: 100px; height: auto"
                :src="scope.row.resourceIcon"
                :preview-src-list="[scope.row.resourceIcon]"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="nums" label="数量" align="center" />
          <el-table-column prop="propValue" label="靓号id">
          </el-table-column>

          <el-table-column prop="expireTimeStr" label="资源时长">
          </el-table-column>
          <el-table-column prop="ctime" label="获得时间"> </el-table-column>
          <el-table-column prop="operator" label="操作人"> </el-table-column>
          <el-table-column prop="mtime" label="操作时间"> </el-table-column>

          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                type="warning"
                size="mini"
                @click="operate(5, scope.row.id)"
                >删除</el-button
              >
            </template></el-table-column
          >
        </el-table>
      </el-row>
      <el-row>
        <el-pagination
          :current-page.sync="search.page"
          layout="total, prev, pager, next"
          background
          @current-change="handleCurrentChange"
          :total="search.total"
          class="pagination"
          :page-size="30"
        ></el-pagination>
      </el-row>
    </el-row>
    <el-dialog
      append-to-body
      title="新增"
      :visible.sync="dialog"
      :before-close="cancel"
      width="50%"
    >
      <div class="item">
        <span>用户rid：</span>
        <el-input v-model="form.ridListStr" type="textarea" />
        <el-upload
          class="upload-demo"
          :limit="1"
          action=""
          :on-change="addExcel"
          ref="upload"
        >
          <el-button type="primary" size="mini">批量上传</el-button>
        </el-upload>
      </div>
      <div class="item">
        <div>
          <span>资源id：</span>
          <el-input v-model="prop.propId" type="text" />
        </div>
        <div>
          <span>资源类型：</span>
          <el-select
            filterable
            v-model="prop.propType"
            clearable
            placeholder=""
          >
            <el-option
              v-for="(item, itemIndex) in propTypeList"
              v-bind:key="itemIndex + 99"
              :label="item.name"
              :value="item.values"
            ></el-option>
          </el-select>
        </div>
        <div v-if="prop.propType == 4">
          <span>数量：</span>
          <el-input
            v-model="prop.nums"
            type="text"
            placeholder="默认1个"
            style="width: 100px"
          />
        </div>
        <div v-if="prop.propType == 12">
          <span>靓号id：</span>
          <el-input
            v-model="prop.propValue"
            type="text"
            placeholder="请输入靓号id"
            style="width: 200px"
          />
        </div>
        <div>
          <span>资源时限：</span>
          <el-switch
            v-model="prop.day"
            active-text="永久"
            inactive-text="非永久"
            :active-value="0"
            :inactive-value="1"
          ></el-switch>
        </div>
        <div v-if="prop.day == 1">
          <span>领取后：</span>
          <el-input
            v-model="prop.expireTime"
            type="number"
            style="width: 100px"
          />
          <span> Days有效</span>
        </div>

        <div>
          <el-button plain type="primary" size="mini" @click="operate(2)"
            >新 增</el-button
          >
        </div>
      </div>
      <div class="item">
        <el-table :data="form.propList" stripe border>
          <el-table-column prop="propId" label="资源ID "> </el-table-column>
          <el-table-column label="资源类型">
            <template slot-scope="scope">
              {{
                propTypeList.find((item) => item.values == scope.row.propType)
                  .name
              }}
            </template>
          </el-table-column>
          <el-table-column label="期限">
            <template slot-scope="scope">
              {{ scope.row.expireTime == 0 ? '永久' : scope.row.expireTime }}
            </template>
          </el-table-column>
          <el-table-column label="数量" prop="nums" />
          <el-table-column label="靓号id" prop="propValue">
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                type="warning"
                size="mini"
                @click="operate(3, scope.$index)"
                >删除</el-button
              >
            </template></el-table-column
          >
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button :loading="upload" type="primary" @click="operate(4)"
          >新 增</el-button
        >
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
    
    <!-- 成本校验确认弹窗 -->
    <el-dialog
      title="成本校验确认"
      :visible.sync="costCheckDialog"
      width="500px"
      :close-on-click-modal="false"
    >
      <div v-if="costInfo.cost">
        <div style="margin-bottom: 15px;">
          <span style="color: #409EFF; font-weight: bold; font-size: 16px;">成本总和(后台金币)：{{ costInfo.cost }}</span>
        </div>
        <div v-if="costInfo.limit" style="margin-bottom: 15px;">
          <span style="color: #909399;">单次下发总成本限制(后台金币)：{{ costInfo.limit }}</span>
        </div>
      </div>
      <div v-if="costInfo.needDynamicKey" style="margin-top: 20px;">
        <div style="margin-bottom: 10px;">
          <span style="color: #E6A23C; font-weight: bold;">需要输入动态验证key：</span>
        </div>
        <el-input
          v-model="form.dynamicKey"
          type="text"
          placeholder="请输入动态验证key"
          style="width: 100%"
        />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button :loading="upload" type="primary" @click="confirmSubmit">确认提交</el-button>
        <el-button @click="costCheckDialog = false">取 消</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      dialog: false,
      upload: false,
      form: {
        ridListStr: '',
        propList: [],
        dynamicKey: '',
      },
      prop: { propType: '', propId: '', expireTime: '', day: 1, nums: 1, propValue: '' },
      costInfo: {
        cost: '',
        limit: '',
        needDynamicKey: false,
        giftIds: [],
      },
      costCheckDialog: false, // 成本校验确认弹窗
      datalist: [],
      propTypeList: [
        { name: '麦位框', values: 1 },
        { name: '气泡框', values: 2 },
        { name: '座驾', values: 3 },
        { name: '礼物', values: 4 },
        { name: 'vip', values: 5 },
        { name: '贵族', values: 6 },
        { name: '勋章', values: 7 },
        { name: '称号', values: 8 },
        { name: '进场特效', values: 9 },
        { name: '资料卡', values: 10 },
        { name: '成就称号', values: 11 },
        { name: '靓号id', values: 12 },
        { name: '个人主页飘屏', values: 16 },
      ],
      expireList: ['永久', '非永久'],
      search: {
        propType: null,
        expireTime: null,
        propId: null,
        rid: null,
        page: 1,
        total: 0,
      },
    }
  },
  created() {
    this.query()
  },
  methods: {
    async addExcel(file) {
      if (this.upload) return
      this.upload = true
      const formdata = new FormData()
      formdata.append('ridFile', file.raw)
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.prop_upload +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        formdata
      )
      this.upload = false
      if (this.form.ridListStr != '') {
        this.form.ridListStr = this.form.ridListStr + ',' + res.data
      } else {
        this.form.ridListStr += res.data
      }
      this.$refs.upload.clearFiles()
    },
    async query() {
      this.loading = true
      const { data: res } = await this.$axios({
        method: 'get',
        url:
          this.$store.getters.path.prop_query +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        withCredentials: true,
        params: this.search,
      })
      this.loading = false
      if (res.code != 0) return this.$message.error(res.msg)
      this.datalist = res.data.data
      this.search.total = res.data.total
      this.$message.success('查询成功')
    },
    handleCurrentChange(num) {
      this.search.page = num
      this.query()
    },
    async operate(type, obj) {
      if (type === 1) {
        this.dialog = true
      } else if (type === 2) {
        if (this.prop.propType !== '' && this.prop.propId !== '') {
          this.prop.expireTime = this.prop.day == 0 ? 0 : this.prop.expireTime
          // 将prop中的nums转成int类型
          this.prop.nums = parseInt(this.prop.nums)
          this.form.propList.push({ ...this.prop })
          this.prop = {
            propType: '',
            propId: '',
            expireTime: '',
            day: 0,
            nums: 1,
            propValue: '',
          }
        }
      } else if (type === 3) {
        this.form.propList.splice(obj, 1)
      } else if (type === 4) {
        if (this.form.ridListStr !== '' && this.form.propList.length !== 0) {
          // 先调用校验接口
          this.upload = true
          try {
            const ridList = this.form.ridListStr.split(',').map(rid => parseInt(rid.trim())).filter(rid => !isNaN(rid))
            if (ridList.length === 0) {
              this.upload = false
              return this.$message.warning('请输入有效的用户rid')
            }
            
            const checkParams = {
              propList: this.form.propList,
              ridList: ridList
            }
            
            const { data: checkRes } = await this.$axios.post(
              this.$store.getters.path.prop_check_cost +
                '?username=' +
                this.$store.getters.username +
                '&token=' +
                this.$store.getters.token,
              checkParams
            )
            
            this.upload = false
            
            if (checkRes.code !== 0) {
              return this.$message.error(checkRes.msg || '成本校验失败')
            }
            
            // 更新成本信息
            this.costInfo = {
              cost: checkRes.data?.cost || '',
              limit: checkRes.data?.limit || '',
              needDynamicKey: checkRes.data?.needDynamicKey || false,
              giftIds: checkRes.data?.giftIds || [],
            }
            
            // 重置动态key输入
            this.form.dynamicKey = ''
            
            // 显示确认弹窗
            this.costCheckDialog = true
          } catch (error) {
            this.upload = false
            console.error('校验失败:', error)
            this.$message.error('成本校验失败，请重试')
          }
        }
      } else if (type === 5) {
        this.$confirm('确认删除此项配置', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const { data: res } = await this.$axios(
            this.$store.getters.path.prop_del +
              '?username=' +
              this.$store.getters.username +
              '&token=' +
              this.$store.getters.token +
              '&id=' +
              obj,
            {}
          )
          if (res.code !== 0) return this.$message.error('删除失败')
          this.$message.success('删除成功')
          this.query()
        })
      }
    },
    async confirmSubmit() {
      // 如果需要动态key但未输入，提示用户
      if (this.costInfo.needDynamicKey && !this.form.dynamicKey) {
        return this.$message.warning('需要输入动态验证key')
      }
      
      // 调用新增接口
      this.upload = true
      try {
        const submitForm = { ...this.form }
        // 如果不需要动态key，则不传dynamicKey字段
        if (!this.costInfo.needDynamicKey) {
          delete submitForm.dynamicKey
        }
        
        const { data: res } = await this.$axios.post(
          this.$store.getters.path.prop_add +
            '?username=' +
            this.$store.getters.username +
            '&token=' +
            this.$store.getters.token,
          submitForm
        )
        this.upload = false
        
        if (res.code != 0) return this.$message.error(res.msg)
        this.$message.success(res.msg)
        this.costCheckDialog = false
        this.cancel()
        this.query()
      } catch (error) {
        this.upload = false
        console.error('提交失败:', error)
        this.$message.error('提交失败，请重试')
      }
    },
    cancel() {
      this.form = { ridListStr: '', propList: [], dynamicKey: '' }
      this.prop = { propType: '', propId: '', expireTime: '', day: 1, nums: 1, propValue: '' }
      this.costInfo = {
        cost: '',
        limit: '',
        needDynamicKey: false,
        giftIds: [],
      }
      this.costCheckDialog = false
      this.dialog = false
    },
  },
}
</script>

<style lang="scss" scoped>
.search {
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  > * {
    margin: 3px;
  }
}

.el-textarea,
.el-input {
  width: 300px;
}

.item {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  border-bottom: 1px solid #efefef;
  padding: 20px 0;

  > * {
    margin: 3px;
  }
}
</style>
